export default {
  0: 'Home',
  1: 'Work',
  2: 'Mailing'
}
